/**
 * Zod schemas for IAM validation
 */

import { z } from 'zod';
import { ClaimsSchema } from '@/modules/idv';

export const JwtPayloadSchema = ClaimsSchema.extend({
  sub: z.string().optional(),
  exp: z.number().optional(),
  iat: z.number().optional(),
  nbf: z.number().optional(),
  iss: z.string().optional(),
});
